module.exports = __webpack_public_path__ + "img/b4_p_m.e0f63a74.svg";